import { CredentialsConfig } from './credentials/CredentialsConfig';
import { StacksConfig } from './stacks/StacksConfig';
import { ClustersConfig } from './cluster/ClustersConfig';
import { DashboardConfig } from './dashboard/DashboardConfig';
import { JobManagerAppConfig } from './job-manager/JobManagerAppConfig';
import { FileManagerAppConfig } from './file-manager/FileManagerAppConfig';
import { SettingsConfig, SettingsUser } from './settings/SettingsConfig';

import { Error404PageConfig } from './pages/errors/404/Error404PageConfig';
import { Error500PageConfig } from './pages/errors/500/Error500PageConfig';

import { VerifyPageConfig } from './pages/verify/VerifyPageConfig';
import { LandingPageConfig } from './pages/landing/LandingPageConfig';

import { ProfilePageConfig } from './pages/profile/ProfilePageConfig';

import { RecoverPasswordPageConfig } from './pages/password-recover/RecoverPasswordPageConfig';
import { AccountConfig } from './account/AccountConfig';
import { HeidiAppsConfig } from './heidi-apps/HeidiAppsConfig';
import { TrainingsConfig } from './trainings/TrainingsConfig';
import { StudentActivityConfig } from './student-activity/StudentActivityConfig';
import { CoursesConfig } from './courses/CoursesConfig';
import { WorkshopDashboardConfig } from './workshop-dashboard/WorkshopDashboardConfig';
import { LandingPageConfig as DemoLandingPageConfig } from './landing-page/LandingPageConfig';
// Feature: 001-org-multi-tenancy - Organizations management (T034, T066)
import { OrganizationsConfig, MyOrganizationConfig } from './organizations/OrganizationsConfig';
// Cost Research feature for super admin (legacy)
import { CostReportsConfig } from './cost-reports/CostReportsConfig';
// Cloud Analyzer - live inventory management
import { CloudAnalyzerConfig } from './cloud-analyzer/CloudAnalyzerConfig';
// Feature: heidi-storage - per-organization shared document store
import { DocumentsConfig } from './documents/DocumentsConfig';
import { StorageOverviewConfig } from './storage/StorageOverviewConfig';
import { WatsonxConfig } from './watsonx/WatsonxConfig';

export const appsConfigs = [
	WatsonxConfig,
	TrainingsConfig,
	StudentActivityConfig,
	CoursesConfig,
	AccountConfig,
	StacksConfig,
	DashboardConfig,
	WorkshopDashboardConfig,
	DemoLandingPageConfig,
	ClustersConfig,
	SettingsConfig,
	HeidiAppsConfig,
	SettingsUser,
	VerifyPageConfig,
	CredentialsConfig,
	ProfilePageConfig,
	LandingPageConfig,
	Error404PageConfig,
	Error500PageConfig,
	JobManagerAppConfig,
	FileManagerAppConfig,
	RecoverPasswordPageConfig,
	OrganizationsConfig,
	MyOrganizationConfig,
	CostReportsConfig,
	CloudAnalyzerConfig,
	DocumentsConfig,
	StorageOverviewConfig
];
